import React, { useState } from "react"
import { Campaign } from "../types/CampaignDatas"
import { CalendarDaysIcon, CurrencyDollarIcon } from "@heroicons/react/24/outline"
import { faCopy } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface CampaignCardProps {
  campaign: Campaign
}

const CampaignCard: React.FC<CampaignCardProps> = ({ campaign }) => {
  const [isCopied, setIsCopied] = useState<boolean>(false)

  const copyToClipboard = (_id: string) => {
    navigator.clipboard.writeText(`https://teamfluencer.co/app?campaignId=${_id}`)
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 1200)
  }

  return (
    <div
      className="
        relative 
        flex-shrink-0 w-64 p-5 bg-white rounded-2xl 
        shadow-md border border-gray-100 
        hover:shadow-lg transition-all duration-300 cursor-pointer
      "
      onClick={() => window.open(`/campaigns/find/${campaign._id}`, "_blank")}
    >
      {/* Sağ üst kopyalama butonu */}
      <button
        onClick={(e) => {
          e.stopPropagation() // kart tıklamasını engelle
          copyToClipboard(campaign._id)
        }}
        className="absolute top-3 right-3 bg-gray-100 hover:bg-gray-200 p-2 rounded-full shadow"
      >
        <FontAwesomeIcon icon={faCopy} className="text-gray-600" />
      </button>

      {/* Kopyalandı Badge */}
      {isCopied && (
        <span className="absolute top-3 right-14 px-2 py-1 text-xs bg-black text-white rounded">
          {"Kampanya Url'i Kopyalandı!"}
        </span>
      )}

      {/* Üst Görsel */}
      <img
        src={campaign.cover_photo || "https://via.placeholder.com/150"}
        alt={campaign.name}
        className="w-20 h-20 rounded-full object-cover mx-auto mb-3 shadow-sm"
      />

      {/* Kampanya İsmi */}
      <h3 className="text-center text-lg font-semibold text-gray-800 leading-tight line-clamp-2">
        {campaign.name}
      </h3>

      {/* Platform + Yayında Badge */}
      <div className="mt-2 flex items-center justify-center gap-2">
        <span className="px-3 py-0.5 text-xs rounded-full bg-indigo-100 text-indigo-700 font-medium">
          {campaign.platform}
        </span>

        <span
          className={`px-3 py-0.5 text-xs rounded-full font-medium ${
            campaign.visibility ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
          }`}
        >
          {campaign.visibility ? "Yayında" : "Pasif"}
        </span>
      </div>

      {/* Barter */}
      <div className="mt-3 text-center">
        <span className="text-sm font-medium text-gray-700">Barter:</span>
        <span className="text-sm text-gray-500 ml-1">{campaign.barter ? "Evet" : "Hayır"}</span>
      </div>

      {/* Bütçe */}
      <div className="mt-3 flex items-center justify-center gap-1 text-gray-700">
        <CurrencyDollarIcon className="w-5 h-5 text-emerald-600" />
        <span className="font-semibold">{campaign.estimated_budget}</span>
        <span className="text-gray-500 text-sm">{campaign.currency}</span>
      </div>

      {/* Kampanya Tarih Aralığı */}
      <div className="mt-4 text-center flex flex-col items-center">
        <div className="flex items-center gap-2 text-gray-600 mb-1">
          <CalendarDaysIcon className="w-5 h-5" />
          <span className="text-sm font-medium">Kampanya Aralığı</span>
        </div>

        <p className="text-xs text-gray-500">
          {campaign?.campaign_start ? new Date(campaign.campaign_start).toLocaleDateString() : ""} -{" "}
          {campaign?.campaign_end ? new Date(campaign.campaign_end).toLocaleDateString() : ""}
        </p>
      </div>
    </div>
  )
}

export default CampaignCard
